import {CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import {SelectedAssetComponent} from './selected-asset.component';
import {CustomElementService} from '../../../../formbird-sc-shared/src/lib/services/custom-element.service';
import {GeoAutoCompleteModule} from '../../../../formbird-mapping/src/lib/geo-auto-complete/geo-auto-complete.module';
import {SanitizingModule} from '../../../../formbird-mapping/src/lib/sanitizing/sanitizing.module';
import { default as pjson } from '../../../../../package.json';
import {StreetDataModule} from '../../../../formbird-mapping/src/lib/street-data/street-data.module';
import {ComponentSetupModule} from '../../../../formbird-sc-shared/src/lib/component-setup.module';
import {ValidationMessageModule} from '../../../../formbird-sc-shared/src/lib/components/validation/validation-message.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatTooltipModule,
    HttpClientModule,
    GeoAutoCompleteModule,
    SanitizingModule,
    StreetDataModule,
    ComponentSetupModule,
    ValidationMessageModule
  ],
  exports: [
    SelectedAssetComponent
  ],
  declarations: [
    SelectedAssetComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  providers: []
})

export class SelectedAssetModule {
  constructor(private injector: Injector, private customElementService: CustomElementService) {
    customElementService.convertToCustomElement(SelectedAssetComponent, 'sc-selected-asset', this.injector, pjson.version);

  }
}
